import {
  DefaultBox,
  FloatingBox,
  SideBox,
  VisualBox,
} from '../../etc/LBox/LBox';
import Observer from '../../etc/Observer/Observer';
import { UnderLineText } from '../../typography/Typography.styled';

import useLanding from '../../../application/bloc/useLanding';
import useFooter from '../../../application/hooks/useFooter';

import {
  Button,
  Spacer,
  SimpleItem,
  Divider,
  HeadTitle,
  TheFooter,
  SpacerSection,
  Trg16,
  Tmd14,
  Trg11,
} from 'oui';

import FAQ from '../../../application/staticData/info/FAQ';
import main_visual from '../../../assets/images/feature/feature-mtg-visual.png';
import main_visual2 from '../../../assets/images/feature/feature-mtg-visual2.png';
import main_partners from '../../../assets/gif/partners.gif';
import { AccordionList } from '../../etc/Accordion/AccordionList';
import { PAGE_NM } from '../../../application/types/types';
import { Wrap } from '../../etc/Accordion/Accordion.styled';
import React from 'react';
import { ClkBtnSubEventNm } from '../../../application/hooks/useBeacon';
import useMtgLanding from '../../../application/bloc/useMtgLanding';
import Faq from '../../component/Faq/Faq';

const MtgLanding = () => {
  const {
    navigateOvertake,
    navigateOvertakePrivacy,
    navigateOnlineLoanCorp,
    navigateTestPage,
  } = useFooter();

  const {
    navigatePartners,
    navigateBannerToPage,
    navigateResult,

    sendBeaconClkBtn,
    sendBeaconClkBtnBnkList,

    isTodayRequested,
    isFloating,
    setIsFloating,

    resetMortgageInfo,
    media,
    terms,
  } = useLanding(PAGE_NM.MTG_HOME);

  const {
    isLoading,
    simpleList,
    hasPreRequest,
    hasRequest,
  } = useMtgLanding();

  const handleClickMainButton = (e?: any) => {
    const txt = e.target.innerHTML || '';
    const isResult = txt === '담보 조회 결과 보기';
    sendBeaconClkBtn(
        isResult // todo 가심사 여부로 처리
        ? ClkBtnSubEventNm.ViewResucc
        : ClkBtnSubEventNm.LoanApp,
      txt,
    );
    if(isResult){
      navigateResult();
    } else{
      void terms.showTerm({ EVENT_STATE: 'mtg' });
    }
  };

  const handleClickSubButton = (e?: any) => {
    const txt = e.target.innerHTML || '';
    sendBeaconClkBtn(ClkBtnSubEventNm.ReResucc, txt);
    // 혹시 모르니 입력하고 있던 담보물 정보 reset
    resetMortgageInfo();
    void terms.showTerm({ EVENT_STATE: 'mtg' });
  };

  const handleClickPartnersButton = (e: any) => {
    sendBeaconClkBtnBnkList(e.target.innerText || '');
    navigatePartners();
  };
  const handleClickSimpleList = (item: any) => {
    sendBeaconClkBtn(item.beacon.subEventName, item.beacon.buttonName);
    navigateBannerToPage(0, item.navigate.destination);
  };

  const ctaButton = (
    <Button
      configuration={'contained'}
      flexible={true}
      onClick={(e: any) => handleClickMainButton(e)}
      children={hasPreRequest ? '담보 조회 결과 보기' : '1분 안에 비교하기'} // todo 가심사 여부로 처리
    />
  );

  return (
    <>
      { !isLoading && 
        <></>
      }
      { isLoading &&
        <>
          <VisualBox>
            <img src={main_visual} alt={'main-visual'} />
          </VisualBox>
          <DefaultBox>
            <Observer handleState={(e: any) => setIsFloating(e)}>
              {ctaButton}
            </Observer>
            <Spacer size={'md'} />
            { (hasPreRequest) &&
              <Button
                configuration={'ghost'}
                flexible={true}
                onClick={(e) => handleClickSubButton(e)}
                size={'md'}
                children={'다른 담보로 다시 조회하기'}
              />
            }
            
          </DefaultBox>
          <FloatingBox status={isFloating}>{ctaButton}</FloatingBox>
          <SideBox>
            {simpleList.map((item: any, idx: number) => {
              return (
                <div key={idx + item.subheaderText}>
                  <SimpleItem
                    key={idx + item.subheaderText}
                    state={item.avatar.state}
                    avatar={item.avatar}
                    headerText={item.headerText}
                    subheaderText={item.subheaderText}
                    stress={false}
                    onClickSimpleItem={() => handleClickSimpleList(item)}
                  />
                  {idx < simpleList.length - 1 && <Spacer size={'sm'} />}
                </div>
              );
            })}
            <Spacer size={'sm'} />
          </SideBox>
          <Divider type={'contents'} />
          <SpacerSection
            size={'md'}
            children={
              <>
                <HeadTitle
                  textTitle={'다양한 금융사를\n 한 곳에서 비교할 수 있어요'}
                />
                <VisualBox>
                  <img src={main_partners} alt={'main-partners'} />
                </VisualBox>
                <UnderLineText onClick={handleClickPartnersButton}>
                  함께하는 금융사
                </UnderLineText>
              </>
            }
          />
          <Divider type={'contents'} />
          <SpacerSection
            size={'md'}
            children={
              <>
                <HeadTitle
                  textTitle={
                    '원하시는 목적에 맞게\n 대출 상품을 신청할 수 있어요'
                  }
                />
              </>
            }
          />
          <SideBox>
            <VisualBox>
              <img src={main_visual2} alt={'main_visual2'} />
            </VisualBox>
          </SideBox>
          <Spacer size={'lg'} />
          <Divider type={'contents'} />

          <SpacerSection
            size={'md'}
            children={
              <>
                <HeadTitle textTitle={'주택 담보 관련 자주 묻는 질문'} />
                <AccordionList
                  list={FAQ.map((item, itemIndex) => {
                    return {
                      title: <Trg16 text={item.title} />,
                      content: (
                        <Wrap key={`faq_${itemIndex}_content`}>
                          {item.content.map((contentItem: any, idx: number) => {
                            return (
                              <div key={idx + 'content'}>
                                {contentItem.title && (
                                  <Tmd14 text={contentItem.title} color={'#696969'} />
                                )}
                                {contentItem.description && (
                                  <Trg11
                                    text={contentItem.description}
                                    color={'#696969'}
                                  />
                                )}
                              </div>
                            );
                          })}
                        </Wrap>
                      ),
                    };
                  })}
                />
              </>
            }
          />
          <TheFooter
            type={'a'}
            onClickOnlineLoanCorp={navigateOnlineLoanCorp}
            onClickOvertake={navigateOvertake}
            onClickOvertakePrivacy={navigateOvertakePrivacy}
            onClickTest={navigateTestPage}
            media={media}
          />
          <Spacer size='lg'/>
          <Spacer size='md'/>
        </>
      }
    </>
  );
};

export default MtgLanding;
